import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import contactimage from '../assets/img/2.png';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

const Contact = () => {
  // Form State Management
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [statusMessage, setStatusMessage] = useState("");

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Form Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    try {
      const response = await fetch("https://jiimpex.com/new_project/ji-impex/contact_send_email.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      setStatusMessage(result.message);
    } catch (error) {
      console.error("Error:", error);
      setStatusMessage("Something went wrong. Try again later.");
    }
  };


  return  (
    <>
      {/* Page Title */}
      <Helmet>
        <title>Contact Us || JI IMPEX</title>
      </Helmet>

      <div class="container-fluid contact-page page-header py-5 mb-5 wow fadeIn" data-wow-delay="0.1s" style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeIn' }}>

        <div class="container text-center py-5">

          <h1 class="display-4 text-white  slideInDown mb-4">Contact Us</h1>

          <nav aria-label="breadcrumb animated slideInDown">

            <ol class="breadcrumb justify-content-center mb-0">

              <li class="breadcrumb-item"><a class="text-white" href="/">Home</a></li>

              <li class="breadcrumb-item text-primary active" aria-current="page">Contact Us</li>

            </ol>

          </nav>

        </div>

      </div>

      {/* Contact Details & Form */}
      <Container className="py-5">
        <Row className="g-5 align-items-center">
          {/* Contact Details */}
          <Col lg={6}>
            <h3>Contact Details</h3>
            <p>For any kind of query, contact us with the details below.</p>

            <h5>Address</h5>
            <p>
              <p class="icon-text"><i class="fa fa-map-marker-alt fa-3x"></i>City Survey No.170/89 Pakki Plot No.89/B, Vibrant Industrial Park, Moti Talab Marg, Kumbhar Vada, Bhavnagar,Gujarat, 364006</p>
              {/* <i className="fa fa-map-marker-alt fa-3x"></i> V.I.P, Moti Talav Rd,
              Bhavnagar, Gujarat 364006 */}
            </p>
            <br/>
            <h5>Email</h5>
            <p>
              <p class="icon-text">
                <i className="far fa-envelope-open fa-3x"></i>{" "}
                <a href="mailto:sales@jiimpex.com">sales@jiimpex.com</a>
              </p>
            </p>
            <p>
              <p class="icon-text">
                <i className="far fa-envelope-open fa-3x"></i>{" "}
                <a href="mailto:j.i.impex77@gmail.com">j.i.impex77@gmail.com</a>
              </p>
            </p>
            <br/>
            <h5>Call Support</h5>
            {/* <p>
              <strong>Proprietor: Mr. Amin Hamidani</strong>
              <br />
              <p class="icon-text">
                <i className="fa fa-phone-alt fa-3x"></i>{" "}
                <a href="tel:+919825207250">+91 982 520 7250</a>
              </p>
            </p> */}

            <p>
              {/* <strong>Sales Executive: Mr. Abdullah Hamidani</strong> */}
              <br />
              <p class="icon-text">
                <i className="fa fa-phone-alt fa-3x"></i>{" "}
                <a href="tel:+919316819979">+91 931 681 9979</a>
              </p>
              {/* <p class="icon-text">
                <i className="fa fa-phone-alt fa-3x"></i>{" "}
                <a href="tel:+919265677400">+91 926 567 7400</a>
              </p> */}
            </p>

            {/* <p>
              <strong>Manager: Mr. Khalid Hamidani</strong>
              <br />
              <p class="icon-text">
                <i className="fa fa-phone-alt fa-3x"></i>{" "}
                <a href="tel:+918140489293">+91 814 048 9293</a>
              </p>
            </p> */}
          </Col>

          <Col lg={6}>
            <img src={contactimage} alt="Contact Image" />
          </Col>
        </Row>

        {/* Contact Form */}
        <Row className="mt-5">
          {/* Google Maps */}
          <Col lg={6}>
            <iframe
              className="w-100"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3704.8717451841935!2d72.13947257601956!3d21.785224261366345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395f5ba0e0147531%3A0x1e22a3a680af91a0!2sJ.%20I.%20IMPEX!5e0!3m2!1sen!2sin!4v1739799398435!5m2!1sen!2sin"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
              title="Company Location"
            ></iframe>
          </Col>
          
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.5s"
            style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeIn" }}
          >
            <div className="border-start border-5 border-primary ps-4 mb-5">
              <h6 className="text-body text-uppercase mb-2">Contact Us</h6>
              <h1 className="display-6 mb-0">If You Have Any Query, Please Contact Us</h1>
            </div>

            <form onSubmit={handleSubmit} method="POST">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control border-0 bg-light"
                      id="name"
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    <label htmlFor="name">Your Name</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="email"
                      className="form-control border-0 bg-light"
                      id="email"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <label htmlFor="email">Your Email</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control border-0 bg-light"
                      id="subject"
                      name="subject"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                    <label htmlFor="subject">Subject</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating">
                    <textarea
                      className="form-control border-0 bg-light"
                      placeholder="Leave a message here"
                      id="message"
                      name="message"
                      style={{ height: "150px" }}
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                    <label htmlFor="message">Message</label>
                  </div>
                </div>

                <div className="col-12">
                  <button className="btn btn-primary py-3 px-5" type="submit">
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Row>
      </Container>

    </>
  );
};

export default Contact;
